import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-address-page',
  templateUrl: './edit-address-page.component.html',
  styleUrls: ['./edit-address-page.component.scss']
})
export class EditAddressPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
